import classNames from 'classnames';

export type ArrowDownIconProps = {
    className?: classNames.Argument;
    color?: string;
    size?: string;
};

export const ArrowDownIcon = (props: ArrowDownIconProps) => {
    const { color = '#000000', size = '16px', className } = props;

    return (
        <svg
            className={classNames(className)}
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8536 4.89645C14.0488 5.09171 14.0488 5.40829 13.8536 5.60355L8.35355 11.1036C8.15829 11.2988 7.84171 11.2988 7.64645 11.1036L2.14645 5.60355C1.95118 5.40829 1.95118 5.09171 2.14645 4.89645C2.34171 4.70118 2.65829 4.70118 2.85355 4.89645L8 10.0429L13.1464 4.89645C13.3417 4.70118 13.6583 4.70118 13.8536 4.89645Z"
            ></path>
        </svg>
    );
};
